module.exports = __webpack_public_path__ + "assets/img/faspay_707.7af4ed50.png";